
import Component, { mixins } from "vue-class-component"
import FilialeHeader from "../custom/FilialeHeader.vue"
import ServiceAnfordernLogic from "@/logic/bestellung/service_anfordern_logic"
import Calculator from "../mixins/Calculator.vue"

@Component({ components: { FilialeHeader } })
export default class ServiceAnfordern extends mixins(Calculator) {
  logic: ServiceAnfordernLogic = null

  mounted() {
    this.logic = new ServiceAnfordernLogic()
    this.logic.init()
  }

  absenden() {
    this.logic.absenden()
  }
}
